import { createSlice } from "@reduxjs/toolkit";
import { getTopSoldCategories } from "./topSoldCategoriesAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  categories: [],
  latestRequestId: null,
};

const topSoldCategorySlice = createSlice({
  name: "topSoldCatgories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTopSoldCategories.pending, (state, action) => {
        state.loading = true;
        state.categories = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getTopSoldCategories.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.categories = action.payload;
        state.error = null;
      })
      .addCase(getTopSoldCategories.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default topSoldCategorySlice.reducer;
